import React, { useEffect, useState } from 'react';
import { Row, Col, Input, Button, Card, CardHeader, CardBody, Tooltip } from 'reactstrap';
import Select from 'react-select';
import { Trash } from 'react-feather';
import { AiFillInfoCircle } from 'react-icons/ai';

import { useDispatch, useSelector } from 'react-redux';
import { GET_BENEFITS_GAMEFICATION, GET_BENEFITS_GAMEFICATION_POINT } from '../../../../../../../../store/actions';
import cogoToast from 'cogo-toast';

const rewardOptions = [
  { value: 'points', label: 'Points' },
  { value: 'benefits', label: 'Benefits' },
];

const Form2 = ({ prizePoolRows, setPrizePoolRows, onNext, rowErrors, setRowErrors, isUpdate }) => {
  const dispatch = useDispatch();
  const [benefitOptions, setBenefitOptions] = useState([]);
  const [ttop, setttop] = useState(false);

  const { getBenefits, getBenefitsLoading, getBenefitsPoint } = useSelector((state: any) => ({
    getBenefits: state?.GetBenefitsGamification?.data,
    getBenefitsLoading: state?.GetBenefitsGamification?.loading,
    getBenefitsPoint: state?.GetBenefitsGamificationPoint?.data,
  }));

  useEffect(() => {
    if (getBenefits !== null) {
      // setBenefitOptions(
      //   getBenefits?.inventory?.map(benefit => {
      //     return { value: benefit?.id, label: benefit?.name, isDisabled: benefit.is_no_benefit };
      //   }),
      // );
      setBenefitOptions(
        (getBenefits?.inventory || []).map((benefit, idx) => ({
          value: benefit.id,
          label: benefit.name,
          isDisabled:
            prizePoolRows.length <= 1 && // only consider disabling when more than one row
            // apply to options after the first two
            Boolean(benefit.is_no_benefit),
        })),
      );
    }
  }, [getBenefits]);

  useEffect(() => {
    if (isUpdate) {
      dispatch({
        type: GET_BENEFITS_GAMEFICATION,
        payload: {
          urlParams: {
            type: 'benefits',
          },
        },
      });

      dispatch({
        type: GET_BENEFITS_GAMEFICATION_POINT,
        payload: {
          urlParams: {
            type: 'points',
          },
        },
      });
    }
  }, [isUpdate]);

  const handleChange = (index, field, value) => {
    const updatedRows = [...prizePoolRows];
    updatedRows[index][field] = value;
    if (field === 'points') {
      updatedRows[index]['benefits'] = getBenefitsPoint?.inventory?.[0]?.id || '';
    }
    setPrizePoolRows(updatedRows);

    const updatedErrors = [...rowErrors];
    if (updatedErrors[index]?.[field]) {
      updatedErrors[index][field] = undefined;
      setRowErrors(updatedErrors);
    }
  };

  const addRow = () => {
    // setPrizePoolRows([...prizePoolRows, { rewardType: '', points: '', benefit: '', probability: '', maxUnit: '' }]);
    if (prizePoolRows.length <= 9) {
      setPrizePoolRows([...prizePoolRows, { rewardType: '', points: '', benefit: '', probability: '', maxUnit: '' }]);
    } else if (prizePoolRows.length > 9) {
      cogoToast.error('Users are allowed to add a maximum of 10 questions per quiz.');
    }
  };

  const deleteRow = index => {
    const updatedRows = [...prizePoolRows];
    updatedRows.splice(index, 1);
    setPrizePoolRows(updatedRows);
  };

  return (
    <Card>
      <CardHeader className="fw-medium mb-4 d-flex justify-content-between align-items-center fs-16">
        <div>
          <Tooltip
            placement="top"
            isOpen={ttop}
            target="TooltipTop"
            toggle={() => {
              setttop(!ttop);
            }}
          >
            Please Note: Maximum 10 and Minimum 2 can be added
          </Tooltip>
          Prize Pool Configuration{' '}
          <span id="TooltipTop" className="cursor-pointer">
            <AiFillInfoCircle />
          </span>
        </div>

        <Button color="success" onClick={addRow} disabled={prizePoolRows.length > 10}>
          + Add Row
        </Button>
      </CardHeader>
      <CardBody>
        {prizePoolRows?.map((row, index) => (
          <div key={index} className="d-flex align-items-center">
            <Row className="mb-3 d-flex align-items-center" style={{ width: '85%' }}>
              <Col md={3}>
                <label className="form-label">Select Reward Type</label>
                <Select
                  options={rewardOptions}
                  value={rewardOptions.find(opt => opt.value === row.rewardType)}
                  onChange={option => {
                    handleChange(index, 'rewardType', option.value);
                    // Reset conditional fields
                    if (option?.value === 'benefits') {
                      dispatch({
                        type: GET_BENEFITS_GAMEFICATION,
                        payload: {
                          urlParams: {
                            type: option?.value,
                          },
                        },
                      });
                    } else {
                      dispatch({
                        type: GET_BENEFITS_GAMEFICATION_POINT,
                        payload: {
                          urlParams: {
                            type: option?.value,
                          },
                        },
                      });
                    }

                    if (option.value === 'benefits') {
                      handleChange(index, 'benefits', '');
                    } else {
                      handleChange(index, 'points', '');
                    }
                    const updatedErrors = [...rowErrors];
                    if (updatedErrors[index]?.rewardType) {
                      updatedErrors[index].rewardType = undefined;
                      setRowErrors(updatedErrors);
                    }
                  }}
                />
                {rowErrors[index]?.rewardType && <div className="text-danger mt-1">{rowErrors[index].rewardType}</div>}
              </Col>

              {/* Conditional input based on reward type */}
              {row.rewardType === 'points' && (
                <Col md={2}>
                  <label className="form-label">Add Points</label>
                  <Input
                    type="number"
                    value={row.points}
                    onChange={e => handleChange(index, 'points', e.target.value)}
                    onKeyDown={e => {
                      if (e.key === '-' || e.key === ';' || e.key === '.') e.preventDefault();
                    }}
                    onWheel={(e: any) => e.target.blur()} // Disable number scrolling
                  />
                  {rowErrors[index]?.points && <div className="text-danger mt-1">{rowErrors[index].points}</div>}
                </Col>
              )}

              {row.rewardType === 'benefits' && (
                <Col md={2}>
                  <label className="form-label">Add Benefits</label>
                  <Select
                    options={benefitOptions}
                    value={benefitOptions.find(opt => opt.value === row.benefits)}
                    onChange={option => handleChange(index, 'benefits', option.value)}
                  />
                  {rowErrors[index]?.benefits && <div className="text-danger mt-1">{rowErrors[index].benefits}</div>}
                </Col>
              )}

              <Col md={3}>
                <label className="form-label">Win Probability</label>
                <Input
                  type="number"
                  value={row.probability}
                  onChange={e => handleChange(index, 'probability', e.target.value)}
                  onKeyDown={e => {
                    if (e.key === '-' || e.key === ';' || e.key === '.') e.preventDefault();
                  }}
                  onWheel={(e: any) => e.target.blur()} // Disable number scrolling
                />
                {rowErrors[index]?.probability && <div className="text-danger mt-1">{rowErrors[index].probability}</div>}
              </Col>

              <Col md={2}>
                <label className="form-label">Max Unit Allowed</label>
                <Input
                  type="number"
                  value={row.maxUnit}
                  onChange={e => handleChange(index, 'maxUnit', e.target.value)}
                  onKeyDown={e => {
                    if (e.key === '-' || e.key === ';' || e.key === '.') e.preventDefault();
                  }}
                  onWheel={(e: any) => e.target.blur()} // Disable number scrolling
                />
                {rowErrors[index]?.maxUnit && <div className="text-danger mt-1">{rowErrors[index].maxUnit}</div>}
              </Col>
            </Row>
            <div className="mt-2" style={{ width: '15%' }}>
              {prizePoolRows.length > 1 && !row?.serviceConfigId && (
                <Button color="danger" onClick={() => deleteRow(index)}>
                  <Trash size={16} />
                </Button>
              )}
            </div>
          </div>
        ))}
        <div className="d-flex justify-content-end mt-4">
          <Button color="success" style={{ fontSize: '17px', padding: '6px 40px', borderRadius: '8px' }} onClick={onNext}>
            {isUpdate ? 'Update' : 'Save'}
          </Button>
        </div>
      </CardBody>
    </Card>
  );
};

export default Form2;
